export enum LogType {
  meeting = 'meeting',
  call = 'call',
  email = 'email',
  letter = 'letter'
}



// WEBPACK FOOTER //
// ./client/app/models/logType.ts